import { Deployment } from "store/deployments/deployments.types";
import deploymentStore from "store/deployments/deployments";
import { useToast } from "@dgraph-io/typhoon-ui";
import { ToastContext } from "libs/toast";

export const getKeyValue = (params: any) => {
    return {
        label: params === "true" ? "True" : "False",
        value: params === "true" ? "true" : "false",
    };
};

export const getDefaultSize = (attributes: any, deploymentSize: any) => {
    return attributes
        .filter((attr: any) => attr.name === "size")[0]
        ?.options.filter((v: any) => v.value === deploymentSize)[0];
};

export const updateDeployment = async (deployment: any, patchedObj: any) => {
    const res = await deploymentStore.patchDeployment(deployment, patchedObj);

    return res;
};

export const useUpdateBackend = (deployment: Deployment, patchedObj: any) => {
    const toast = useToast(ToastContext);

    return async () => {
        try {
            const res = await updateDeployment(deployment, patchedObj);

            if (res.status === 200) {
                toast.addToast({
                    description: "Your settings has been updated",
                    variant: "info",
                });
            }
        } catch (error) {
            toast.addToast({
                heading: "Failed to update",
                description:
                    error?.response?.data?.error || "Something went wrong",
                variant: "error",
            });
        }
    };
};
